import http from './httpService';

export function getContractStatusTypeByStatus(statusId) {
	return http.get(`/ContractStatusType/GetByStatus/${statusId}`);
}
